
import ShareConfig from './WxShareConfig';
import ServiceShareConfig from './WxServiceShareConfig';

export default ShareConfig;
export {
  ServiceShareConfig
};
